module.exports = __webpack_public_path__ + "media/images/country_flags/dj-1cdd48bfba7f99d3c9ed0d5b1bc40d19.png";